{
  "version": 1,
  "asset_id": "051e0b9a-11a0-40ba-a18c-bb6a6ffb490b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/051e0b9a-11a0-40ba-a18c-bb6a6ffb490b/foreignaffairs-semrush-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/051e0b9a-11a0-40ba-a18c-bb6a6ffb490b/foreignaffairs-semrush-640.webp",
  "original_filename": "foreignaffairs-semrush-640.webp",
  "size": 15736,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:35Z"
}
